import axios from 'axios';

import deepGet from '~/common/utils/deepGet.js';

import TrialClass from '~/common/stores/trialStore.js';
import FatalErrorClass from '~/common/stores/fatalErrorStore.js';
import FormsClass from '~/common/stores/formStore.js';
import ModalClass from '~/common/stores/modalStore.js';
import SharedFormUtilsClass from '~/common/stores/ui/sharedFormUtils.js';

// created root store
class RootStore {
    constructor() {
        this.fatalErrorStore = new FatalErrorClass();
        this.sharedFormUtilsStore = new SharedFormUtilsClass(this);
        this.modalStore = new ModalClass();
        this.formsStore = new FormsClass(this);
        this.trialStore = new TrialClass(this);
    }
}

// init stores
const rootStore = new RootStore();

// intercept all axios requests
axios.interceptors.response.use(
    response => response,
    (err) => {
        // Invalid or expired NumberLockSessionId
        if (deepGet(err, ['reponse', 'data', 'Details', 0, 'ErrorCode']) === 5004) rootStore.fatalErrorStore.setFatalError(true);
        return Promise.reject(err);
    }
);

export default rootStore;
